import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { FacebookOutlineIcon, IconButton, InstagramOutlineIcon, TiktokOutlineIcon, VimeoOutlineIcon, YoutubeOutlineIcon } from "@parkschannel/ui";
export const SocialLinks = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-6",
        children: [
            user.youtube_url && /*#__PURE__*/ _jsx("a", {
                href: user.youtube_url,
                target: "_blank",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ _jsx(YoutubeOutlineIcon, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.facebook_url && /*#__PURE__*/ _jsx("a", {
                href: user.facebook_url,
                target: "_blank",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ _jsx(FacebookOutlineIcon, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.instagram_url && /*#__PURE__*/ _jsx("a", {
                href: user.instagram_url,
                target: "_blank",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ _jsx(InstagramOutlineIcon, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.tiktok_url && /*#__PURE__*/ _jsx("a", {
                href: user.tiktok_url,
                target: "_blank",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ _jsx(TiktokOutlineIcon, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            }),
            user.vimeo_url && /*#__PURE__*/ _jsx("a", {
                href: user.vimeo_url,
                target: "_blank",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    tabIndex: -1,
                    icon: /*#__PURE__*/ _jsx(VimeoOutlineIcon, {
                        className: "text-neutral-900"
                    }),
                    variant: "base",
                    size: "sm"
                })
            })
        ]
    });
};
